interface Props {
  onDismissInitAlert: () => void;
  visibleInitAlert: boolean;
}
const PwaInitAlert: React.FC<Props> = (props: Props) => {
  const { visibleInitAlert, onDismissInitAlert } = props;

  if (visibleInitAlert) {
    return (
      <div className="flex flex-row items-start alert alert-success ">
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            className="w-6 h-6 mx-2 stroke-current"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          اطلاعات این صفحه برای استفاده‌ی آفلاین ذخیره شد. از این پس می‌توانید به صورت آفلاین آخرین وضعیت صفحاتی که از
          آن‌ها بازدید کرده‌اید را مشاهده نمایید.
        </span>
        <button className="btn btn-success btn-sm" onClick={() => onDismissInitAlert()}>
          متوجه شدم
        </button>
      </div>
    );
  } else {
    return null;
  }
};

export default PwaInitAlert;
